import { Component, Inject, NgZone, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerAddress } from 'src/app/models/customer-address';
import { CustomerAddressService } from 'src/app/services/customer-address.service';
import { LocaleService } from 'src/app/services/locale.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-confirm-address-dialog',
  templateUrl: './confirm-address-dialog.component.html',
  styleUrls: ['./confirm-address-dialog.component.scss']
})
export class ConfirmAddressDialogComponent implements OnInit 
{
  street='';
  placenumber='';
  neighboubourhood='';
  zipcode='';
  reference='';
  addressString='';
  locale:string | undefined;

  latitude=0;
  longitude=0;

  constructor
  (
    private localeservice:LocaleService,
    public alertDialog:MatDialog,
    public dialogRef: MatDialogRef<ConfirmAddressDialogComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: { address_components:google.maps.GeocoderAddressComponent[], geometry:google.maps.GeocoderGeometry, formatted_address: string, locale: 'pt-BR' | 'en-IE' | undefined, distance:number, originID:string, afertto:string, locationID:string}
  ) { }

  ngOnInit(): void 
  {
    this.getData();
  }

  onConfirm():void
  {
    if(this.checkData())
    {
      if(this.locale === 'pt-BR')
        this.addressString = `${this.street}, ${this.placenumber}, ${this.neighboubourhood}`;

      var address = new CustomerAddress();

      address.SetDataFromLocation(this.street, this.placenumber, this.neighboubourhood, this.zipcode, this.data.distance, this.data.geometry.location.lat(),this.data.geometry.location.lng(), this.addressString, this.data.originID, this.data.locationID)

      this.dialogRef.close(address);
    }
    else
      this.showWarning();
  }

  onCancel(): void 
  {
    this.dialogRef.close();
  }

  getData()
  {
    this.locale = this.data.locale;

    this.latitude = this.data.geometry?.location.lat() | 0;
    this.longitude = this.data.geometry?.location.lng() | 0;

    if(this.data.locale === 'pt-BR')
    {
      var street = this.data.address_components?.find(x => x.types.includes("route"));

      if (street)
          this.street = street.long_name;

      var placeNumber = this.data.address_components?.find(x => x.types.includes("street_number"));

      if (placeNumber)
          this.placenumber = placeNumber.long_name;

      var neighbourhood = this.data.address_components?.find(x => x.types.includes("neighborhood" || "colloquial_area" || "locality " || "sublocality" || "sublocality_level_1" || "sublocality_level_2"  || "sublocality_level_3" || "sublocality_level_4" || "sublocality_level_5"));

      if (neighbourhood)
          this.neighboubourhood = neighbourhood.long_name;

      var zipcode = this.data.address_components?.find(x => x.types.includes("postal_code"));

      if (zipcode)
          this.zipcode = zipcode.long_name;
    }

    if(this.data.locale === 'en-IE')
    {
      this.addressString = this.data.formatted_address; 
    }
  }

  checkData()
  {
    if(this.locale == 'en-IE')
    {
      if(this.addressString.length === 0 )
        return false;

      return true;
    }
    
    if(this.street.length === 0 || this.placenumber.length === 0 || this.neighboubourhood.length === 0 || this.zipcode.length === 0)
      return false;

    return true;
  }

  showWarning()
  {
      this.alertDialog.open(AlertDialogComponent, {
      height: 'fit-content',
      width: 'fit-content',
      data: 
      { 
        title:this.localeservice.instantTranslation("Dialogs.Alert.FormWarning.Title"), 
        detail:this.localeservice.instantTranslation("Dialogs.Alert.FormWarning.Detail"), 
        accept:this.localeservice.instantTranslation("Dialogs.Alert.FormWarning.Accept") 
      }
    });
  }
}
